import { AgencyInfo, Branch } from '../interfaces/User';

export class UserB2CModel {
  firstName: string;
  lastName: string;
  email: string;
  workTel: string;
  mobile: string;

  constructor(user?: AgencyInfo['user']) {
    if (user) {
      this.firstName = user.user_f_name || '';
      this.lastName = user.user_l_name || '';
      this.email = user.user_email || '';
      this.workTel = user.work_tel_1 || '';
      this.mobile = user.mobile_1 || '';
    } else {
      this.firstName = '';
      this.lastName = '';
      this.email = '';
      this.workTel = '';
      this.mobile = '';
    }
  }
}

export class BranchB2CModel {
  displayOnOrderCP: boolean;
  city: string;
  address: string;
  tel1: string;
  tel2: string;
  email1: string;
  email2: string;
  branchTitle: string;
  branchDesc: string;
  sbr_pcc: string;
  logo?: {
    base64File: string;
    mimeType: string;
  };

  constructor(branch?: Branch) {
    if (branch) {
      this.displayOnOrderCP = branch.displayOnOrderCP;
      this.city = branch.city;
      this.address = branch.address;
      this.tel1 = branch.tel1;
      this.tel2 = branch.tel2;
      this.email1 = branch.email1;
      this.email2 = branch.email2;
      this.branchTitle = branch.branchTitle;
      this.branchDesc = branch.branchDesc;
      this.sbr_pcc = branch.sbr_pcc;
    } else {
      this.displayOnOrderCP = false;
      this.city = '';
      this.address = '';
      this.tel1 = '';
      this.tel2 = '';
      this.email1 = '';
      this.email2 = '';
      this.branchTitle = '';
      this.branchDesc = '';
      this.sbr_pcc = '';
    }
  }
}
